<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    maximized
    class="custom-font text-uppercase"
    transition-show="slide-down"
    transition-hide="slide-up"
  >
    <!-- Dialogs -->
    <editar-item :modalidad_id="solicitud.modalidad_id" />
    <advertencia/>
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="aprobar()">
        <q-card-section class="text-center text-white">
          <div class="row">
            <div class="col-xs-2">
              <q-btn round color="white" icon="arrow_back" class="bg-pragma" @click="closeDialog()" />
            </div>
            <div class="col-xs-8">
              <span class="text-h6 text-bold">Aprobar solicitud</span>
            </div>
            <div class="col-xs-2">

            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="col-xs-12 q-pa-sm">
            <q-select
              v-model="form.selectProyectos"
              :options="proyectos"
              label="Proyecto"
              option-label="nombre"
              option-value="id"
              emit-value
              map-options
              outlined
              dense
              label-color="grey"
              dark
              :rules="[v => !!v || 'Requerido']"
              @update:model-value="verificaProyecto()"
            ></q-select>
          </div>
          <div class="col-xs-12 q-pa-sm">
              <div class="row">
                <div class="col-xs-6 q-gutter-xs">
                  <strong>Items para solicitud</strong>
                </div>
                <div class="col-xs-6 text-right">
                  <strong>Total: {{util.numberMoney(total)}}</strong>
                </div>
              </div>
            </div>
            <div class="col-xs-12 q-px-sm">
              <q-list bordered separator dark>
                <q-item
                  class="text-uppercase"
                  @click="editarItemSolicitud(item)"
                  v-for="(item, index) in items"
                  :key="item.detalle"
                  :class="index%2 == 0 ? 'bg-grey-9' : 'bg-grey-8'"
                  clickable
                >
                  <q-item-section>
                    <q-item-label>{{item.detalle}}</q-item-label>
                    <q-item-label caption>Cant.: {{~~item.cantidad}}</q-item-label>
                  </q-item-section>

                  <q-item-section side top>
                    <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                    <q-item-label class="text-right text-caption q-pt-lg text-bold">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-xs-12 text-center">
              <q-checkbox
                v-model="observar"
                label="¿Desea realizar alguna observación?"
                dark
              ></q-checkbox>
            </div>
            <div class="col-xs-12" v-if="observar">
              <q-input
                v-model="form.des_observacion"
                type="textarea"
                label="Describa sus observaciones"
                class="tu"
                autogrow
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="Cancelar"
                color="negative"
                icon="clear"
                class="full-width"
                @click="closeDialog()"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="Aprobar"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
// import { useStore } from 'vuex'
import util from '../../../../../plugins/util'
import EditarItem from './EditarItem.vue'
import Advertencia from './Advertencia.vue'

export default {
  components: {
    EditarItem,
    Advertencia
  },
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const $q = useQuasar()
    // const store = useStore()
    
    const dialog = ref(false)
    const observar = ref(false)
    const loading = ref(false)
    const proyectos = ref([])
    const form = ref({
      modalAprobar_solicitud_id: null,
      modalAprobar_empresa_id: null,
      selectProyectos: null,
      tipocompra: [],
      des_observacion: ""
    })
    const items = ref([])
    const total = ref(0)
    const solicitud = ref(null)

    // Métodos y funciones
    const getProyectos = async (empresa_id) => {
      try {
        let res = await axios.get(`json/proyectos/empresa/${empresa_id}`)
        proyectos.value = res.data
      } catch (error) {
        console.log(error)
      }
    }
    
    const verificaProyecto = async () => {
      try {
        let res = await axios.get(`json/existe_proyecto/${solicitud.value.historial.solicitud.usuario_id}/${form.value.selectProyectos}`)
        if (!res.data.valor) {
          bus.emit('openDialogAdvertenciaSolicitud', {
            proyecto: getProjectName(form.value.selectProyectos),
            nro: solicitud.value.numero,
            usuario: solicitud.value.usuario
          })
          form.value.selectProyectos = solicitud.value.proyecto_id
        }
      } catch (error) {
        console.log(error)
      }
    }

    const getProjectName = (id) => {
      let res = 'Proyecto'
      proyectos.value.forEach(elem => {
        if (elem.id == id) {
          res = elem.nombre
        }
      })
      return res
    }

    const aprobar = async () => {
      try {
        loading.value = true
        if (observar.value) {
          form.value.observa = 'on'
        }
        form.value.platform = util.getPlatform()
        await axios.put('solicitudes/modificar/aprobador', form.value)
        $q.notify({
          message: 'Solicitud aprobada',
          color: 'positive'
        })
        closeDialog()
        bus.emit('closeDialogEventoAutorizar')
      } catch (error) {
        console.log(error)
        loading.value = false
      }
      /* try {
        loading.value = true
        let platform
        if ($q.platform.is.platform === 'android') {
          platform = 'A'
        } else if ($q.platform.is.platform === 'iphone') {
          platform = 'I'
        } else {
          platform = 'W'
        }
        let data = {
          id_solicitud: solicitud_id.value,
          motivo: observacion.value,
          id_rol: store.state.auth.user.rol_id,
          platform
        }
        if (store.state.auth.user.revisor == 1) {
          data.id_rol = 4
        }
        await axios.post('solicitud-observacion', data)
        $q.notify({
          message: 'Solicitud observada',
          color: 'positive'
        })
        closeDialog()
        bus.emit('closeDialogEventoAutorizar')
      } catch (error) {
        loading.value = false
        return console.log(error)
      } */
    }

    const editarItemSolicitud = (item) => {
      item.edit = true
      bus.emit('openDialogEditarItem', item)
    }

    const sumarTotalItems = () => {
      let suma = 0
      items.value.forEach(item => {
        suma += item.subtotal
      })
      total.value = suma
    }

    const closeDialog = () => {
      form.value = {
        modalAprobar_solicitud_id: null,
        modalAprobar_empresa_id: null,
        selectProyectos: null,
        tipocompra: [],
        des_observacion: ""
      }
      observar.value = false
      loading.value = false
      dialog.value = false
    }

    const updatePurchaseTypeItem  = (id, tipo_compra) => {
      items.value.forEach(elem => {
        if (elem.id == id) {
          elem.tipo_compra = tipo_compra
        }
      })
    }

    // Creación del componente
    bus.on('openDialogAprobarSolicitud', (item) => {
      form.value.selectProyectos = item.solicitud.proyecto_id
      form.value.modalAprobar_solicitud_id = item.solicitud.id
      form.value.modalAprobar_empresa_id = item.solicitud.empresa_id
      items.value = item.solicitud.items
      solicitud.value = item.solicitud
      sumarTotalItems()
      let tipocompra = []
      /* items.value.forEach(elem => {
        tipocompra[elem.id] = elem.tipo_id
      }) */
      items.value.forEach(elem => {
        tipocompra.push({
          item_id: elem.id,
          tipocompra_id: elem.tipo_id
        })
      })
      form.value.tipocompra = tipocompra
      getProyectos(item.solicitud.empresa_id)
      dialog.value = true
    })

    bus.on('actualizarItemAprobador', (item) => {
      updatePurchaseTypeItem(item.id, item.tipo_compra)
      form.value.tipocompra.forEach(elem => {
        if (elem.item_id == item.id) {
          elem.tipocompra_id = item.tipo_compra.id
        }
      })
    })

    // Retorno de variables al template
    return {
      dialog,
      loading,
      closeDialog,
      proyectos,
      items,
      form,
      util,
      total,
      editarItemSolicitud,
      solicitud,
      verificaProyecto,
      aprobar,
      observar
    }
  }
}
</script>

<style>

</style>